import { render, staticRenderFns } from "./SchedulingConfig.vue?vue&type=template&id=826f38e4"
import script from "./SchedulingConfig.vue?vue&type=script&lang=js"
export * from "./SchedulingConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports